// extracted by mini-css-extract-plugin
export default {"modal":"modal__QFNJ1","content":"content__Fl8Lj"};